module.exports = __webpack_public_path__ + "1792395595471/fonts/summernote.f9b5d83.woff";